import { NgTooltip } from "@/atoms/tooltips";

import { VariantProps, cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const flagIconVariants = cva("flag rounded-sm", {
  variants: {
    size: {
      xs: "h-3 text-xs",
      sm: "h-4 text-sm",
      md: "text-md h-5",
      lg: "h-6 text-lg",
    },
    disabled: {
      true: "cursor-not-allowed opacity-50",
    },
  },
  defaultVariants: {
    size: "md",
    disabled: false,
  },
});

export type FlagIconProps = {
  countryCode: string;
  countryName: string;
  className?: string;
} & VariantProps<typeof flagIconVariants>;

/** Depends on flags.css, imported from index.css. */
export const FlagIcon = ({
  countryCode,
  countryName,
  className,
  ...variantProps
}: FlagIconProps) => {
  return (
    <NgTooltip>
      <NgTooltip.Trigger>
        <span
          className={twMerge(
            flagIconVariants({ ...variantProps }),
            `flag-country-${countryCode.toLowerCase()}`,
            className,
          )}
        />
      </NgTooltip.Trigger>
      <NgTooltip.Content>
        <span>{countryName}</span>
      </NgTooltip.Content>
    </NgTooltip>
  );
};
